import { API_BASE_URL } from "../config";

export const BASE_URL = API_BASE_URL;

/** All paths use API_BASE_URL which already includes `/api/v1`. */
export const routes = {
  // ----- AUTH ----- //
  signIn: `${BASE_URL}/user/login`,
  signUp: `${BASE_URL}/user/signup`,
  refreshToken: (refresh) => `${BASE_URL}/user/refresh/${refresh}`,
  logOut: `${BASE_URL}/user/logout`,

  // ----- USER (admin) ----- //
  getAllCustomers: `${BASE_URL}/user/`,
  searchUsers: `${BASE_URL}/user/search`,
  getUserById: `${BASE_URL}/user`,
  updateUser: `${BASE_URL}/user`,
  deleteUser: `${BASE_URL}/user`,
  approveSeller: `${BASE_URL}/user/approve-seller`,

  // ----- ADDRESS (admin) ----- //
  address: `${BASE_URL}/address`,
  createAddress: `${BASE_URL}/address/create`,

  // ----- PRIVACY ----- //
  createPrivacyPolicy: `${BASE_URL}/privacy/create`,
  getPrivacyPolicy: `${BASE_URL}/privacy/`,
  updatePrivacyPolicy: `${BASE_URL}/privacy`,
  deletePrivacyPolicy: `${BASE_URL}/privacy`,

  // ----- TERMS ----- //
  createTermsConditions: `${BASE_URL}/termsandcondition/create`,
  getTermsConditions: `${BASE_URL}/termsandcondition/`,
  updateTermsConditions: `${BASE_URL}/termsandcondition`,
  deleteTermsConditions: `${BASE_URL}/termsandcondition`,

  // ----- VEHICLE CATALOG ----- //
  createVehicleMake: `${BASE_URL}/vehicle-make/create`,
  getAllVehicleMakes: `${BASE_URL}/vehicle-make/`,
  updateVehicleMake: `${BASE_URL}/vehicle-make`,
  deleteVehicleMake: `${BASE_URL}/vehicle-make`,

  createVehicleModel: `${BASE_URL}/vehicle-model/create`,
  getAllVehicleModels: `${BASE_URL}/vehicle-model/`,
  updateVehicleModel: `${BASE_URL}/vehicle-model`,
  deleteVehicleModel: `${BASE_URL}/vehicle-model`,

  createVehicleVariant: `${BASE_URL}/vehicle-model-variant/create`,
  getAllVehicleVariants: `${BASE_URL}/vehicle-model-variant/`,
  updateVehicleVariant: `${BASE_URL}/vehicle-model-variant`,
  deleteVehicleVariant: `${BASE_URL}/vehicle-model-variant`,

  createColour: `${BASE_URL}/colour/create`,
  getAllColours: `${BASE_URL}/colour/`,
  updateColour: `${BASE_URL}/colour`,
  deleteColour: `${BASE_URL}/colour`,

  createTransmission: `${BASE_URL}/transmission/create`,
  getAllTransmissions: `${BASE_URL}/transmission/`,
  updateTransmission: `${BASE_URL}/transmission`,
  deleteTransmission: `${BASE_URL}/transmission`,

  createFuelType: `${BASE_URL}/fuel-type/create`,
  getAllFuelTypes: `${BASE_URL}/fuel-type/`,
  updateFuelType: `${BASE_URL}/fuel-type`,
  deleteFuelType: `${BASE_URL}/fuel-type`,

  // ----- VEHICLES ----- //
  createVehicle: `${BASE_URL}/vehicle/create`,
  getAllVehicles: `${BASE_URL}/vehicle/`,
  getVehicleHome: `${BASE_URL}/vehicle/home`,
  getSellerVehicles: (sellerId) => `${BASE_URL}/vehicle/seller/${sellerId}`,
  updateVehicle: `${BASE_URL}/vehicle`,
  deleteVehicle: `${BASE_URL}/vehicle`,
  vehicleViewed: (vehicleId) => `${BASE_URL}/vehicle/viewed/${vehicleId}`,

  // ----- REPORTS (admin) ----- //
  createReport: `${BASE_URL}/report/create`,
  getAllReports: `${BASE_URL}/report/getall`,
  getOneReport: `${BASE_URL}/report/getone`,
  updateReport: `${BASE_URL}/report/update`,
  deleteReport: `${BASE_URL}/report/delete`,
  getSeenReports: `${BASE_URL}/report/getseen`,
  getUnseenReports: `${BASE_URL}/report/getunseen`,

  // ----- UPLOAD ----- //
  uploadImage: `${BASE_URL}/user/upload`,
};
